import Textfield from '@atlaskit/textfield';
import { jitsiLocalStorage } from '@jitsi/js-utils';
import { Grid } from '@material-ui/core';
import { sha256 } from 'js-sha256';
import _ from 'lodash';
import moment from 'moment';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { notificationDetails, openNotification as openNotifier } from '../../../conference';
import { apiKEY } from '../../../config/constants';
import { fetchAxiosApi } from '../../../mtApi';
import { getBackendSafeRoomName } from '../../../util';
import { isDomainWeborNative } from '../../../util/checkOS';

import { styleWeb } from './style';

declare var config: Object;
const meetingDetails = {
    password: null
};

const styleWidth = { width: '170px' };

const Div = styled.div`
    text-align: center;
    margin: 3%
`;

const Li = styled.li`
margin-top: 20px;
    text-align: center;
    cursor: pointer;
    `;

const H6 = styled.h6`
color: #000 !important;
margin-top: 10px;
text-transform: none;
        font-family: Poppins, sans-serif;
        font-size: 1.1rem;
        font-weight: 500;
        line-height: 1.2;
`;

export const ClaimMeetingDialog = () => {
    const [ meeting, setMeeting ] = useState(meetingDetails);
    const [ errors, setErrors ] = useState(false);
    const userAccessToken = jitsiLocalStorage.getItem('accessToken');
    const { accessToken } = useSelector(state => state['features/base/jwt']);
    const roomName = getBackendSafeRoomName(useSelector(state => state['features/base/conference'].room));
    const { openNotification } = useSelector(state => state['features/base/conference']);
    const { MH_CLIENT_ID } = useSelector(state => state['features/base/config']);
    const { t } = useTranslation();
    const accessTokn = accessToken ?? userAccessToken;
    const dispatch = useDispatch();


    const onMeetingChange = e => {

        const meetingState = {
            ...meeting,
            [e.target.name]: e.target.value
        };

        setMeeting(meetingState);
    };

    /**
    * Toggles donorbox dialog.
    *
    * @returns {void}
    */
    async function submitClaimMeeting() {

        if (!roomName
                    || (meeting.password === null || _.isEmpty(meeting.password))) {
            setErrors(true);

            return false;
        }
        const moement = moment().seconds(0)
        .milliseconds(0)
        .format('X');

        const mesh256 = sha256(`${apiKEY}:MH:${moement}`);


        const metetingClaimer = {
            ...meeting,
            client_id: MH_CLIENT_ID,
            credentials: mesh256,
            ...isDomainWeborNative,
            meeting_id: roomName
        };
        const jsonStrin = JSON.stringify(metetingClaimer);
        const apiFetch = await fetchAxiosApi('meeting/claim_meeting', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessTokn}`
            },
            body: jsonStrin
        });
        const fetchData = await apiFetch;


        if (fetchData?.success) {

            dispatch(notificationDetails({
                alertType: 'success',
                description: 'Your personal Room has been Created'
            }));

            dispatch(openNotifier(!openNotification));
            window.location.reload();
        } else {

            dispatch(notificationDetails({
                alertType: 'warning',
                description: "Your password doesn't match the Meeting password"
            }));

            dispatch(openNotifier(!openNotification));
        }


        setErrors(false);

        return false;
    }

    return (
        <>
            <>
                <Div>
                    <div className = 'text-center'>
                        <img
                            className = 'img-fluid'
                            src = 'images/Upgrade-2.0.png'
                            style = { styleWidth } />
                        <h4
                            style = { styleWeb.h4Style }>
                            We have upgraded our systems and launched 2.0 version of Meet Hour. Kindly claim this meeting by
                            sharing this meeting password and doing a free signup at Meet Hour.
                        </h4>
                    </div>
                </Div>
                <br />
                <H6 >Claimed meeting will be visible on your Personal room page -
                    <a href = { `${config.URL_PREFIX}customer/mymeetings` } >
                        { `${config.URL_PREFIX}customer/mymeetings` }</a></H6>
                <span> Meeting URL : {`${window.location.origin}/${roomName}`}</span><br />
                <span>Meeting ID: { roomName}</span><br />
                <Grid
                    alignContent = 'flex-start'
                    container = { true }
                    spacing = { 0 }>
                    <Grid
                        item = { true }
                        md = { 4 }>
                        <span>Meeting Password:</span>
                    </Grid>
                    <Grid
                        item = { true }
                        md = { 8 }>
                        <Textfield
                            autoFocus = { true }
                            isInvalid = { Boolean(meeting.password === null
                                         || _.isEmpty(meeting.password)) && errors }

                            name = 'password'

                            onChange = { e => onMeetingChange(e) }
                            placeholder = { t('dialog.enterMeetingPassword') }
                            type = 'password' />
                        {
                            Boolean(meeting.password === null || _.isEmpty(meeting.password)) && errors
                                ? <span className = 'warning-text-meeting'>
                                    { t('dialog.errorMeetingPassword') }
                                </span>
                                : null
                        }

                    </Grid>

                </Grid>
                <Li
                    className = 'signin-li list-unstyled' ><a
                        onClick = { submitClaimMeeting }
                        style = { styleWeb.signInButton }>Claim Meeting</a></Li>

            </>

        </>
    );
};


